import React, { useContext, useRef, useState } from "react";
import "./Customisation_Product_Form.css";
import { Form, Row, Table } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";
import PhoneInput from "react-phone-input-2";
import { RegxExpression } from "../../../utils/common";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Uploaded_img_holder from "../../common_components/uploaded_img_holder/Uploaded_img_holder";
import Purple_Btn from "../../common_components/common_btn/purple_btn/Purple_Btn";
import { Context } from "../../../utils/context";
import { customiseAddTokart } from "../../../utils/luxuryapis/customization/customization";

const Customisation_Product_Form = ({ product, subVariantId, variantId }) => {
  const {
    control,
    register,
    handleSubmit,
    getValues,
    setError,
    formState: { errors },
  } = useForm();
  const { IMG_URL } = useContext(Context);
  const navigate = useNavigate();
  const location = useLocation();
  const [uploadedImages, setUploadedImages] = useState([]);
  // const showSecondForm = location?.state?.showSecondForm || false;
  const [showSecondForm, setShowSecondForm] = useState(false);

  const variant = product?.product_variants?.find(
    (item) => Number(item.id) === Number(variantId),
  );
  const subvariant = variant?.product_quantities?.find(
    (item) => Number(item.id) === Number(subVariantId),
  );

  const mrp = Number(subvariant?.mrp || 0);
  const price = Number(subvariant?.price || 0);
  const discount = mrp > 0 ? Math.round(((mrp - price) / mrp) * 100) : 0;

  const onSubmit = async (data) => {
    const formData = new FormData();
    formData.append("quantity", 1);
    formData.append("product_id", product?.id);
    formData.append("variant_id", variant?.id);
    formData.append("quantity_id", subVariantId);
    if (data?.category_id?.value) {
      formData.append("category_id", data?.category_id?.value);
    }

    // formData.append("sizes", JSON.stringify(sizedata?.size));
    formData.append("custom_price", product?.product_detail?.customize_price);
    formData.append("requirement", data?.requirement);
    formData.append("custome_design", data?.custome_design);
    // formData.append("company_name", data?.company_name);
    formData.append("name", data?.name);
    formData.append("email", data?.email);
    formData.append("contact_no", data?.contact_no);
    if (uploadedImages.length > 0) {
      uploadedImages?.map((image, index) => {
        formData.append(`images[${index}]`, image.file);
      });
    }
    const res = await customiseAddTokart(formData);
    if (res?.success) {
      navigate("/luxury/cart");
    } else {
      if (res?.message?.gst_number) {
        setError("gst_number", { message: res?.message?.gst_number });
      }
    }
  };
  console.log(uploadedImages, "uploadedImages uploadedImages main");

  return (
    <section className="Customisation_Form">
      <div className="custom_container">
        <div className="main_div">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              <div className="form_div">
                <div className="row">
                  {/* Left Summary */}
                  <div className="col-md-4 ">
                    <div className="gift_right_summary">
                      <div className="img_holder">
                        <img
                          src={IMG_URL + product?.image1}
                          alt="product img"
                          className="product_img"
                        />
                      </div>

                      <div className="product_title_row">
                        <h2 className="product_title">{product?.name}</h2>
                        <p className="discount_text">{discount}% Discount</p>
                      </div>

                      <div className="summary_table_holder">
                        <Table responsive className="summary_table" borderless>
                          <tbody>
                            <tr>
                              <td className="label">Color</td>
                              <td className="value">
                                <div className="color_img_circle">
                                  <img
                                    src={
                                      IMG_URL +
                                      variant?.product_images[0]?.image
                                    }
                                    alt="color img"
                                    className="product_img"
                                  />
                                </div>
                              </td>
                            </tr>

                            <tr>
                              <td className="label">Size</td>
                              <td className="value">
                                <span className="strike_text">
                                  {subvariant?.name}
                                </span>
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <div className="total_left">
                                  <p className="total_label">Total:</p>
                                </div>
                              </td>
                              <td>
                                <div className="total_right">
                                  <p className="mrp_text">
                                    MRP. ₹ {subvariant?.mrp}
                                  </p>
                                  <p className="selling_price">
                                    Selling Price:{" "}
                                    <span>₹ {subvariant?.price}</span>
                                  </p>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  </div>

                  {/* Right Form */}
                  <div className="col-md-8 ">
                    <Form onSubmit={handleSubmit(onSubmit)}>
                      <Row className="form_container">
                        {/* Name */}
                        <Form.Group className="input_group">
                          <Form.Label>Enter Name</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter Name"
                            {...register("name", {
                              required: "Name is required",
                            })}
                            className={classNames({
                              "is-invalid": errors?.name,
                              "is-valid": getValues("name"),
                            })}
                          />
                          {errors?.name && (
                            <sup className="text-danger">
                              {errors?.name?.message}
                            </sup>
                          )}
                        </Form.Group>

                        {/* Email */}
                        <Form.Group className="input_group">
                          <Form.Label>Enter Email Address</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter Email Address"
                            {...register("email", {
                              required: "Email is required",
                              pattern: {
                                value: RegxExpression.email,
                                message: "Invalid email address",
                              },
                            })}
                            className={classNames({
                              "is-invalid": errors?.email,
                              "is-valid": getValues("email"),
                            })}
                          />
                          {errors?.email && (
                            <sup className="text-danger">
                              {errors?.email?.message}
                            </sup>
                          )}
                        </Form.Group>

                        {/* Contact */}
                        <Form.Group className="input_group">
                          <Form.Label>Contact*</Form.Label>
                          <Controller
                            name="contact_no"
                            control={control}
                            rules={{
                              required: "Field is required",
                            }}
                            render={({ field }) => (
                              <PhoneInput
                                country={"in"}
                                {...field}
                                className={classNames({
                                  "is-invalid": errors?.contact_no,
                                  "is-valid": getValues("contact_no"),
                                })}
                                onChange={(value) => field.onChange(value)}
                                placeholder="Enter Mobile Number"
                              />
                            )}
                          />
                          {errors?.contact_no && (
                            <sup className="text-danger">
                              {errors?.contact_no?.message}
                            </sup>
                          )}
                        </Form.Group>

                        {/* Upload Product */}
                        <Form.Group className="input_group">
                          <Form.Label>Add Artwork / Image*</Form.Label>

                          <Uploaded_img_holder
                            setUploadedImages={setUploadedImages}
                            uploadedImages={uploadedImages}
                          />
                        </Form.Group>

                        <hr />

                        {/* Upload Notes */}
                        <div className="upload_note_div">
                          <p className="note_main_text">
                            UPLOAD YOUR DESIGN SAMPLE/S, SO THAT WE WILL GET TO
                            YOUR IDEA.
                          </p>
                          <p className="note_sub_text">
                            (Upload Preferences: 10 Mb Max PDF, AI, EPS, JPG,
                            PNG, JPEG)
                          </p>
                        </div>

                        {/* Radio */}
                        {/* <Form.Group className="input_group">
                          <Form.Check
                            type="radio"
                            label="Add Custom Design"
                            value="yes"
                            {...register("custome_design")}
                          />
                          <p className="radio_bottom_text">
                            (Add Logo / Artwork)
                          </p>
                        </Form.Group> */}

                        {/* Message */}
                        <Form.Group className="input_group">
                          <Form.Label>Add Details</Form.Label>
                          <Form.Control
                            type="text"
                            name="requirement"
                            placeholder="Enter Details"
                            {...register("requirement", {
                              // required: "Special Requests is required",
                            })}
                            className={classNames("", {
                              "is-invalid": errors?.requirement,
                              "is-valid": getValues("requirement"),
                            })}
                          />
                          {errors?.requirement && (
                            <sup className="text-danger">
                              {errors?.requirement?.message}
                            </sup>
                          )}
                        </Form.Group>

                        {/* Submit */}
                        <div className="btn-holder">
                          <Purple_Btn
                            btnText={"Submit & Add To Cart"}
                            // onClick={() => navigate("/luxury/cart")}
                            type="submit"
                          />
                        </div>
                      </Row>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Customisation_Product_Form;
